import { startOfDay, subDays } from 'date-fns'

import { PeriodOption } from './date-picker.types'
import { getToday } from './date-picker.utils'

export const YEARS_RANGE = 110
export const HEADER_DROPDOWN_OFFSET = 4

export const PERIOD_OPTIONS: PeriodOption[] = [
  {
    getValue: (timezone) => {
      const today = getToday(timezone)
      return [today, today]
    },
    label: 'Today',
  },
  {
    getValue: (timezone) => {
      const yesterday = subDays(getToday(timezone), 1)
      return [yesterday, yesterday]
    },
    label: 'Yesterday',
  },
  {
    getValue: (timezone) => {
      const today = getToday(timezone)
      const weekAgo = startOfDay(subDays(today, 6))
      return [weekAgo, today]
    },
    label: 'Last 7 days',
  },
  {
    getValue: (timezone) => {
      const today = getToday(timezone)
      const twoWeeksAgo = startOfDay(subDays(today, 13))
      return [twoWeeksAgo, today]
    },
    label: 'Last 14 days',
  },
  {
    getValue: (timezone) => {
      const today = getToday(timezone)
      const monthAgo = startOfDay(subDays(today, 29))
      return [monthAgo, today]
    },
    label: 'Last 30 days',
  },
]
